import React, { useEffect, useState } from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { ProfileDetails } from "../../../model/settings/SettingsPersonalInfoModel";
import Center from "../../../widget/common/ui/Center";
import Loader from "../../../widget/common/ui/Loader";
import Div from "../../../widget/common/ui/Div";
import SettingsPersonalInfoForm from "./widget/SettingsPersonalInfoForm";
import { Col } from "react-bootstrap";
import { SettingsPersonalProfileContextImport } from "../../../provider/settings/manage_personal_profile/SettingsPersonalProfileContextProvider";
import DisableContent from "../../../widget/common/ui/DisableContent";

const SettingsPersonalInfoContent = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  const { getProfileInfo, profileDetail, allowEdit } =
    SettingsPersonalProfileContextImport();

  const [profileInfo, setProfileInfo] = useState<ProfileDetails | null>(null);

  useEffect(() => {
    getProfileInfo();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setProfileInfo(profileDetail);
  }, [profileDetail]);

  return (
    <>
      <Div className="h-100">
        {profileInfo == null ? (
          <Center className="h-100">{Loader.normal()}</Center>
        ) : (
          <Col xs={12} lg={8} className="mx-auto pt-5">
            <DisableContent status={!allowEdit}>
              <SettingsPersonalInfoForm profile={profileInfo} type={type} />
            </DisableContent>
          </Col>
        )}
      </Div>
    </>
  );
};

export default SettingsPersonalInfoContent;
